export function RichTextResponsiveTable(selector) {
    let tables = document.querySelectorAll(selector);
    if (tables.length === 0) return;

    let init = (table) => {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        let tableInner = table.querySelector('table');
        let scrollButtons = document.createElement('DIV');
        if (tableInner.scrollWidth <= tableInner.getBoundingClientRect().width) return;

        let intLabels = JSON.parse(table.closest('.rich-text').dataset.labels);
        scrollButtons.classList.add('container__scroll-buttons');
        scrollButtons.innerHTML = `
            <button class="container__scroll-button container__scroll-button--left" id="scroll-left" aria-label="${intLabels.left}" title="${intLabels.left}"></button>
            <button class="container__scroll-button container__scroll-button--right container__scroll-button--is-available" id="scroll-right" aria-label="${intLabels.right}" title="${intLabels.right}"></button>`;
        let scrollButtonsArray = Array.from(scrollButtons.querySelectorAll('button'));

        table.prepend(scrollButtons);
        let buttonLeft = scrollButtons.querySelector('.container__scroll-button--left');
        let buttonRight = scrollButtons.querySelector('.container__scroll-button--right');

        scrollButtonsArray.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                let type = 'left';
                if (e.target.classList.contains('container__scroll-button--right')) {
                    type = 'right';
                }

                tableInner.scrollTo({
                    top: 0,
                    left: tableInner.scrollLeft + window.innerWidth * (type === 'left' ? -1 : 1),
                    behavior: 'smooth',
                });
            });
        });

        window.addEventListener(
            'scroll',
            (e) => {
                let isResponsiveTable =
                    e.target.tagName === 'TABLE' && e.target.parentNode?.classList.contains('table');
                if (!isResponsiveTable) return;

                //buttons
                let containerRect = tableInner.getBoundingClientRect();
                let isEdgeLeft = tableInner.scrollLeft <= 10;
                let isEdgeRight = tableInner.scrollWidth - tableInner.scrollLeft - containerRect.width <= 10;

                buttonLeft.classList[isEdgeLeft ? 'remove' : 'add']('container__scroll-button--is-available');
                buttonRight.classList[isEdgeRight ? 'remove' : 'add']('container__scroll-button--is-available');
            },
            true
        );
    };

    Array.from(tables).forEach((element) => {
        init(element);
    });
}
